import { render, staticRenderFns } from "./ChevronDownIcon.vue?vue&type=template&id=4a0ed051"
import script from "./ChevronDownIcon.vue?vue&type=script&lang=ts"
export * from "./ChevronDownIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports